import { Injectable } from '@angular/core';

@Injectable()
export class ShareService {
  private search:any;

  setSearch(search:any) {
    this.search = search;
  }

  getSearch():any {
    return this.search; 
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/services/share.service.ts